import React from "react"
import Showcase from "../components/Showcase"
import { Image } from "react-ame-components"

export class ImageExample extends React.Component {
  render() {
    return (
      <Showcase
        centerGrid
        title="Componente Image"
        description="Este componente serve apenas para exibir uma imagem na tela.">
        <Image src={"https://picsum.photos/seed/2/420/270"} />
      </Showcase>
    )
  }
}
